


var name = 'konos-file'

export default {

  name: name,


  data: () => ({
    name: name,
  }),
}



/** WEBPACK FOOTER **
 ** ./src/js/components/konos-file/index.js
 **/